const STORAGE_SEARCH = 'leon_revisiontecnica_search';
const STORAGE_DETALLE_AGENDAMIENTO = 'leon_revisiontecnica_detalle_agendamiento';
const STORAGE_PERSONAL_INFORMATION = 'leon_revisiontecnica_personal_information';

const getStorage = (key) => {
  try {
    if (import.meta.client) {
      const value = localStorage.getItem(key);
      return value ? JSON.parse(value) : null;
    }
  } catch (error) {
    console.warn(`[revisiontecnica/store] Error leyendo ${key}:`, error);
  }
  return null;
};

const setStorage = (key, data) => {
  try {
    if (import.meta.client) {
      localStorage.setItem(key, JSON.stringify(data));
    }
  } catch (error) {
    console.warn(`[revisiontecnica/store] Error guardando ${key}:`, error);
  }
};

const state = () => ({
  searchData: {
    local: '',
    local_id: null,
    modo_busqueda: 'por_patente',
    patente: '',
    marca: '',
    ano: '',
    modelo: '',
    version: '',
    ubicacion: '',
    latitud: null,
    longitud: null,
    calle_nombre: '',
    calle_numero: '',
    region: '',
    comuna: '',
  },
  detalle_agendamiento: {
    local_direccion: '',
    local_resumen: '',
    local_info: null,
    vehiculo: null,
    servicio_principal: null,
    servicios_asociados: [],
    total: 0,
    modalidad: 1,
    fecha: null,
    hora: null,
    tempario: '',
    dejar_auto: false,
    direccion_retiro: {
      region: '',
      comuna: '',
      direccion: '',
      comentario: '',
    },
    direccion_entrega: {
      region: '',
      comuna: '',
      direccion: '',
      comentario: '',
    },
  },
  personalInformation: {
    rut: '',
    nombre: '',
    apellido_paterno: '',
    apellido_materno: '',
    email: '',
    telefono: '',
    pais: '+56',
    patente: '',
    patente_pais: '',
  },
});

const mutations = {
  LOAD_FROM_STORAGE(state) {
    const storedSearch = getStorage(STORAGE_SEARCH);
    if (storedSearch) {
      state.searchData = { ...state.searchData, ...storedSearch };
      setStorage(STORAGE_SEARCH, state.searchData);
    }

    const storedDetalle = getStorage(STORAGE_DETALLE_AGENDAMIENTO);
    if (storedDetalle) {
      if (typeof storedDetalle.modalidad === 'string') {
        const map = { ESPERA: 1, DEJA: 2, RETIRA: 3 };
        storedDetalle.modalidad = map[storedDetalle.modalidad] || 1;
      }

      state.detalle_agendamiento = {
        ...state.detalle_agendamiento,
        ...storedDetalle,
      };
      setStorage(STORAGE_DETALLE_AGENDAMIENTO, state.detalle_agendamiento);
    }

    const storedPersonal = getStorage(STORAGE_PERSONAL_INFORMATION);
    if (storedPersonal) {
      state.personalInformation = {
        ...state.personalInformation,
        ...storedPersonal,
      };
      setStorage(STORAGE_PERSONAL_INFORMATION, state.personalInformation);
    }
  },

  RESET_SEARCH_DATA(state) {
    state.searchData = {
      local: '',
      local_id: null,
      modo_busqueda: 'por_patente',
      patente: '',
      marca: '',
      ano: '',
      modelo: '',
      version: '',
      ubicacion: '',
      latitud: null,
      longitud: null,
      calle_nombre: '',
      calle_numero: '',
      region: '',
      comuna: '',
    };

    if (import.meta.client) {
      localStorage.removeItem(STORAGE_SEARCH);
    }
  },

  RESET_DETALLE_AGENDAMIENTO(state) {
    state.detalle_agendamiento = {
      local_direccion: '',
      local_resumen: '',
      local_info: null,
      vehiculo: null,
      servicio_principal: null,
      servicios_asociados: [],
      total: 0,
      modalidad: 1,
      fecha: null,
      hora: null,
      tempario: '',
      dejar_auto: false,
      direccion_retiro: {
        region: '',
        comuna: '',
        direccion: '',
        comentario: '',
      },
      direccion_entrega: {
        region: '',
        comuna: '',
        direccion: '',
        comentario: '',
      },
    };

    if (import.meta.client) {
      localStorage.removeItem(STORAGE_DETALLE_AGENDAMIENTO);
    }
  },

  RESET_PERSONAL_INFORMATION(state) {
    state.personalInformation = {
      rut: '',
      nombre: '',
      apellido_paterno: '',
      apellido_materno: '',
      email: '',
      telefono: '',
      pais: '+56',
      patente: '',
      patente_pais: '',
    };

    if (import.meta.client) {
      localStorage.removeItem(STORAGE_PERSONAL_INFORMATION);
    }
  },

  SET_SEARCH_DATA(state, data) {
    state.searchData = { ...state.searchData, ...data };
    setStorage(STORAGE_SEARCH, state.searchData);
  },

  SET_PATENTE_SEARCH(state, { patente, local, local_id }) {
    const idFinal = local_id === undefined ? state.searchData.local_id : local_id;

    state.searchData = {
      ...state.searchData,
      patente,
      local,
      local_id: idFinal ?? null,
      modo_busqueda: 'por_patente',
      marca: '',
      ano: '',
      modelo: '',
      version: '',
    };

    setStorage(STORAGE_SEARCH, state.searchData);
  },

  SET_AUTO_SEARCH(state, { marca, ano, modelo, local, local_id }) {
    const idFinal = local_id === undefined ? state.searchData.local_id : local_id;

    state.searchData = {
      ...state.searchData,
      marca,
      ano,
      modelo,
      local,
      local_id: idFinal ?? null,
      modo_busqueda: 'por_auto',
      patente: '',
      version: '',
    };

    setStorage(STORAGE_SEARCH, state.searchData);
  },

  SET_DETALLE_AGENDAMIENTO(state, data) {
    state.detalle_agendamiento = {
      ...state.detalle_agendamiento,
      ...data,
    };
    setStorage(STORAGE_DETALLE_AGENDAMIENTO, state.detalle_agendamiento);
  },

  SET_PERSONAL_INFORMATION(state, data) {
    state.personalInformation = {
      ...state.personalInformation,
      ...data,
    };
    setStorage(STORAGE_PERSONAL_INFORMATION, state.personalInformation);
  },
};

const getters = {
  getSearchData(state) {
    return state.searchData;
  },
  getDetalleAgendamiento(state) {
    return state.detalle_agendamiento;
  },
  getPersonalInformation(state) {
    return state.personalInformation;
  },
  getFullData(state) {
    return {
      searchData: state.searchData,
      detalle_agendamiento: state.detalle_agendamiento,
      personalInformation: state.personalInformation,
    };
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions: {},
};
